var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"grey--text"},[_vm._v(" © GreenShade 2022 ")]),_c('v-divider'),_c('span',{staticClass:"grey--text mx-4"},[_vm._v(" Terms ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }